import { createSlice } from '@reduxjs/toolkit'
import { IPatientData } from '../types/patientDetails.types'

const initialState: IPatientData = {
  patientData: null,
}

const patientSlice = createSlice({
  name: 'patientData',
  initialState: initialState,
  reducers: {
    updatePatientData: (state, action) => {
      state.patientData = action.payload
    },
  },
})

export const { updatePatientData } = patientSlice.actions

export default patientSlice.reducer
